/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { ttpFoundersUrl } from 'SharedDir/backend/endpoints/founder-person';
import { TTPRegistries } from 'SharedDir/declarations/ttp-registries';

export class FounderPersonApiClass extends SimpleApi<TTPRegistries.Founder, TTPRegistries.Founder> {
  constructor() {
    super(ttpFoundersUrl);
  }
}
